import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  getEspecialidades(): any {
    return api.get(`/especialidades`)
  },
}
